import React from 'react';
// import {Link} from 'react-router-dom';
import queryString from 'query-string';
import ConfirmDialog from '../dialogs/ConfirmDialog';
import {Trans} from 'react-i18next';
import button from 'bootstrap/js/src/button';
import InfoDialog from '../dialogs/InfoDialog';
/**
 * ActionButton component that generates different types of buttons based on the specified `type`.
 * @param {string} type - The type of button to render.
 * @param {Function} onClick - The click handler function for the button.
 * @param {string} id - The unique identifier for the button.
 * @param {string} url - The URL associated with the button.
 * @param {object} query - The query parameters for the URL.
 * @param {boolean} disabled - Indicates whether the button is disabled.
 * @param {object} customize - Customization options for the button(className, icon, text).
 * @param {string} disableDesc - The description to show in InfoDialog when the button is disabled.
 * @param {Function} onRefresh - The refresh handler function after button click.
 * @param  {string} confirmTitle- The title to show in ConfirmDialog
 */

const Button = ({
  type,
  onClick,
  id,
  url,
  query,
  disabled = false,
  customize,
  disableDesc = 'Failed',
  onRefresh,
  confirmTitle = <Trans i18nKey="c.dialog.sure">Are you sure?</Trans>,
}) => {
  const getEnableButtonType = () => {
    switch (type) {
      case 'reset':
        return (
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => {
              if (disabled) return;
              onClick();
            }}
            disabled={disabled}
          >
            <i className="fa fa-undo" />
            <Trans i18nKey="c.table.filters.reset">Reset</Trans>
          </button>
        );
      case 'edit':
        return (
          // <Link
          //   className="btn btn-sm btn-primary btn-icon kt-margin-5"
          //   disabled={disabled}
          //   to={query ? `${url}?${queryString.stringify(query)}` : `${url}`}
          // >
          //   <i className="fa fa-edit" />
          // </Link>
          <button
            className="btn btn-sm btn-primary btn-icon kt-margin-5"
            disabled={disabled}
            onClick={() => {
              if (onClick) {
                onClick();
              } else if (url) {
                window.location.href = query
                  ? `${url}?${queryString.stringify(query)}`
                  : `${url}`;
              }
            }}
          >
            <i className="fa fa-edit" />
          </button>
        );
      case 'add':
        return (
          <button
            key={`add-${id}`}
            type="button"
            className="btn btn-sm btn-danger btn-icon kt-margin-5"
            onClick={onClick}
          >
            <i className="fa fa-plus" />
          </button>
        );
      case 'saveAs':
        return (
          <ConfirmDialog
            placement="top"
            key={`saveAs-${id}`}
            confirmCallback={() => {
              if (disabled) {
                return;
              }
              onClick();
            }}
          >
            <button
              type="button"
              className="btn btn-sm blue-hoki margin-bottom-5"
              disabled={disabled}
            >
              <i className="fa fa-copy" />
            </button>
          </ConfirmDialog>
        );
      case 'delete':
        return (
          <ConfirmDialog
            placement="top"
            title={confirmTitle}
            key={`delete-${id}`}
            confirmCallback={() => {
              if (disabled) {
                return;
              }
              onClick();
              if (onRefresh) onRefresh();
            }}
          >
            <button
              type="button"
              className="btn btn-sm btn-icon btn-outline-danger kt-margin-5"
              disabled={disabled}
            >
              <i className="fa fa-times" />
            </button>
          </ConfirmDialog>
        );
      case 'discard':
        return (
          <ConfirmDialog
            placement="top"
            key={`discard-${id}`}
            confirmCallback={() => {
              if (disabled) {
                return;
              }
              onClick();
            }}
          >
            <button
              type="button"
              className="btn btn-sm yellow-gold margin-bottom-5"
              disabled={disabled}
            >
              <i className="fa fa-trash" />
            </button>
          </ConfirmDialog>
        );
      case 'submit':
        return (
          <ConfirmDialog
            placement="top"
            key={`submit-${id}`}
            confirmCallback={() => {
              if (disabled) {
                return;
              }
              onClick();
            }}
          >
            <button
              type="button"
              className="btn btn-sm blue margin-bottom-5"
              disabled={disabled}
            >
              <i className="fa fa-check" />
            </button>
          </ConfirmDialog>
        );
      case 'publish':
        return (
          <ConfirmDialog
            placement="top"
            key={`publish-${id}`}
            confirmCallback={() => {
              if (disabled) {
                return;
              }
              onClick();
            }}
          >
            <button
              type="button"
              className="btn btn-sm green margin-bottom-5"
              disabled={disabled}
            >
              <i className="fa fa-arrow-circle-up" />
            </button>
          </ConfirmDialog>
        );
      case 'export':
        return (
          <button
            key={`export-${id}`}
            type="button"
            className="btn btn-sm grey-mint btn-default margin-bottom-5"
            disabled={disabled}
            onClick={() => {
              if (disabled) return;
              onClick();
            }}
          >
            <i className="fa fa-file-excel-o" />
          </button>
        );
      // case 'cancel':
      //   return (
      //     <ConfirmationTextDialog
      //       placement="top"
      //       key={`cancel-${id}`}
      //       confirmCallback={msg => {
      //         if (disabled) {
      //           return;
      //         }
      //         if (needRefresh) {
      //           onClick(msg).then(refreshFn);
      //           return;
      //         }
      //         onClick(msg);
      //       }}
      //     >
      //       <button type="button" className="btn btn-sm grey-mint margin-bottom-5">
      //         <i className="fa fa-times-circle-o" />
      //       </button>
      //     </ConfirmationTextDialog>
      //   );
      case 'copy': {
        return (
          <button
            className="btn btn-sm btn-success btn-icon kt-margin-5"
            onClick={() => onClick()}
          >
            <i className="fa fa-copy" />
          </button>
        );
      }
      case 'customize': {
        let {className, text, style} = customize;
        className = className || 'btn btn-danger kt-margin-b-10';
        style = {...style};
        return (
          <button
            type="button"
            className={className}
            style={style}
            onClick={() => {
              if (disabled) return;
              onClick();
            }}
          >
            {text && text}
          </button>
        );
      }
      case 'customizeConfirm': {
        const {className, icon, text} = customize;
        return (
          <ConfirmDialog
            placement="top"
            title={confirmTitle}
            key={`customize-${id}`}
            confirmCallback={() => {
              if (disabled) {
                return;
              }
              onClick();
            }}
          >
            <button className={`btn ${className}`}>
              {icon && <i className={`fa ${icon}`} />}
              {text && text}
            </button>
          </ConfirmDialog>
        );
      }
      // case 'customizeConfirmText': {
      //   const {className, icon, text} = customize;
      //   return (
      //     <ConfirmationTextDialog
      //       placement="top"
      //       key={`customize-${id}`}
      //       confirmCallback={msg => {
      //         if (disabled) {
      //           return;
      //         }
      //         if (needRefresh) {
      //           onClick(msg).then(refreshFn);
      //           return;
      //         }
      //         onClick(msg);
      //       }}
      //     >
      //       <button className={`btn btn-sm ${className}`}>
      //         <i className={`fa ${icon}`} />
      //       </button>
      //     </ConfirmationTextDialog>
      //   );
      // }
      default:
        return null;
    }
  };
  const getDisableButtonType = () => {
    switch (type) {
      case 'delete':
        return (
          <button
            type="button"
            className="btn btn-sm btn-outline-danger btn-icon kt-margin-5"
            disabled
            style={{pointerEvents: 'none'}}
          >
            <i className="fa fa-times" />
          </button>
        );
      case 'copy': {
        return (
          <button
            type="button"
            className="btn btn-sm btn-success btn-icon kt-margin-5"
            disabled
            style={{pointerEvents: 'none'}}
          >
            <i className="fa fa-copy" />
          </button>
        );
      }
      case 'edit': {
        return (
          <button
            type="button"
            className="btn btn-sm btn-primary btn-icon kt-margin-5"
            disabled
            style={{pointerEvents: 'none'}}
          >
            <i className="fa fa-edit" />
          </button>
        );
      }
      case 'customize': {
        let {className, text, style} = customize;
        className = className || 'btn btn-danger kt-margin-b-10';
        style = {
          ...style,
          display: 'inline-block',
          cursor: 'not-allowed',
          pointerEvents: 'none',
        };
        return (
          <button className={className} style={style} disabled>
            {text && text}
          </button>
        );
      }
      case 'discard':
        return (
          <button
            type="button"
            className="btn btn-sm btn-icon kt-margin-5"
            disabled
            style={{pointerEvents: 'none'}}
          >
            <i className="fa fa-trash" />
          </button>
        );
      default:
        return null;
    }
  };

  if (disabled) {
    return (
      <InfoDialog trigger={'click'} placement={'top'} description={disableDesc}>
        <div
          style={{
            cursor: 'not-allowed',
          }}
        >
          {getDisableButtonType()}
        </div>
      </InfoDialog>
    );
  }

  return <div>{getEnableButtonType()}</div>;
};

export default Button;
